"use client";
import {NeoButton} from "@/components/forms";
import {NeoBreadcrumb, NeoHeader} from "@/components/shared";
import {NeoSwitchInput} from "@/components/shared/neo-switch/neo-switch-input";
import {useNeoContext} from "@/context/neo/neo.context";
import {convertKMTOM, convertMTOKM} from "@/libs/helper";
import {NeoDashboardService} from "@/service/dashboard.service";
import {ChangeEvent, useEffect, useRef, useState} from "react";
import toast from "react-hot-toast";
import {widgetnames} from "../dashboard/dashboard";

export const DeviationSettings: React.FC = () => {
  const breadCrumb = [
    {
      link: "/operations",
      label: "More"
    },
    {
      link: "/operations?tabid=settings",
      label: "Settings"
    },
    {
      link: "",
      label: "Deviation Settings"
    }
  ];
  const [loading, setLoading] = useState(false);
  const {filterContext} = useNeoContext();
  const [speedLimit, setSpeedLimit] = useState({
    min: 0,
    max: 0,
    value: 0
  });
  const [distanceLimit, setDistanceLimit] = useState({
    min: 0,
    max: 0,
    value: 0
  });
  const [fuelLimits, setfuelLimits] = useState({
    min: 0,
    max: 0,
    value: 0
  });
  const [speedTooltipPosition, setSpeedTooltipPosition] = useState(0);
  const [distanceTooltipPosition, setDistanceTooltipPosition] = useState(0);
  const [fuelTooltipPosition, setfuelTooltipPosition] = useState(0);
  const speedDivRef = useRef<HTMLInputElement>(null);
  const distanceDivRef = useRef<HTMLInputElement>(null);
  const fuelDivRef = useRef<HTMLInputElement>(null);
  const showFuelLimit = Boolean(widgetnames[14]);

  const handleTooltipPosition = (divRef: any) => {
    if (!divRef.current) return 0;
    const slider = divRef.current;
    const sliderWidth = slider.offsetWidth;
    const min = parseInt(slider.min, 10);
    const max = parseInt(slider.max, 10);
    const value = parseInt(slider.value, 10);
    const percentage = ((value - min) / (max - min)) * 100;
    return (percentage / 100) * sliderWidth;
  };

  useEffect(() => {
    const speedTooltipposition = handleTooltipPosition(speedDivRef);
    if (speedTooltipposition) {
      setSpeedTooltipPosition(speedTooltipposition);
    }

    const distanceTooltipPosition = handleTooltipPosition(distanceDivRef);
    if (distanceTooltipPosition) {
      setDistanceTooltipPosition(distanceTooltipPosition);
    }

    if (showFuelLimit) {
      const fuelTooltipPosition = handleTooltipPosition(fuelDivRef);
      if (fuelTooltipPosition) {
        setfuelTooltipPosition(fuelTooltipPosition);
      }
    }
  }, [speedLimit, distanceLimit, fuelLimits, showFuelLimit]);

  useEffect(() => {
    usersetting();
  }, []);

  const usersetting = async () => {
    await NeoDashboardService.onGetSettingDatas().then((response: any) => {
      if (response.data) {
        var responsedatas = response.data;
        if (responsedatas?.status == "success") {
          if (responsedatas?.data) {
            const responsedata = responsedatas?.data;
            if (responsedata?.speed) {
              const speed = responsedata?.speed;
              var speedmin = speed.min;
              var speedmax = speed.max;
              var speedvalue = speed.value;
              setSpeedLimit((prevData: any) => ({
                ...prevData,
                ["min"]: speedmin,
                ["max"]: speedmax,
                ["value"]: speedvalue
              }));
            }
            if (responsedata?.distance) {
              const distance = responsedata?.distance;
              var distancemin: any = parseFloat(convertMTOKM(distance.min));
              var distancemax: any = parseFloat(convertMTOKM(distance.max));
              var distancevalue: any = parseFloat(convertMTOKM(distance.value));
              setDistanceLimit((prevData: any) => ({
                ...prevData,
                ["min"]: distancemin,
                ["max"]: distancemax,
                ["value"]: distancevalue
              }));
            }
            if (responsedata?.fuel) {
              const fuel = responsedata?.fuel;
              var fuelmin = fuel.min;
              var fuelmax = fuel.max;
              var fuelvalue = fuel.value;
              setfuelLimits((prevData: any) => ({
                ...prevData,
                ["min"]: fuelmin,
                ["max"]: fuelmax,
                ["value"]: fuelvalue
              }));
            }
          } else {
            toast.error(response?.message);
          }
        } else {
          toast.error(response?.message);
        }
      }
    });
  };

  const speedlimitchange = async (e: ChangeEvent<any>) => {
    const newValue = e.target.value;
    const updatedSpeedLimit = {...speedLimit, value: newValue};
    setSpeedLimit(updatedSpeedLimit);
    const speedPosition = handleTooltipPosition(speedDivRef);
    setSpeedTooltipPosition(speedPosition);
    //await updateusersetting(updatedSpeedLimit, distanceLimit);
  };

  const distancelimitchange = async (e: ChangeEvent<any>) => {
    const newValue = Number(e.target.value);
    const updatedDistanceLimit = {...distanceLimit, value: newValue};
    setDistanceLimit(updatedDistanceLimit);
    const distancePosition = handleTooltipPosition(distanceDivRef);
    setDistanceTooltipPosition(distancePosition);

    //await updateusersetting(speedLimit, updatedDistanceLimit);
  };
  const fuellimitschange = async (e: ChangeEvent<any>) => {
    const newValue = e.target.value;
    const updatedFuelLimit = {...fuelLimits, value: newValue};
    setfuelLimits(updatedFuelLimit);
    const fuelPosition = handleTooltipPosition(fuelDivRef);
    setfuelTooltipPosition(fuelPosition);
  };

  /*const onSubmit = async (
    updatedSpeed = speedLimit,
    updatedDistance = distanceLimit
  ) => {*/
  const onSubmit = async () => {
    const settings: any = [
      {
        type: 1,
        value: speedLimit.value
      },
      {
        type: 2,
        value: convertKMTOM(distanceLimit.value)
      }
    ];
    if (showFuelLimit) {
      settings.push({
        type: 3,
        value: fuelLimits.value
      });
    }
    const requestdatas = {
      settings
    };
    try {
      const response =
        await NeoDashboardService.onSaveUserSetting(requestdatas);
      if (response?.data?.status === "success") {
        toast.success(response?.data?.message);
        usersetting();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (err) {
      toast.error("Sorry! We have technical issues, please try again later.");
    }
  };

  const onReset = () => {
    usersetting();
  };
  return (
    <>
      <div className="flex min-h-[calc(100vh-63px)] w-full flex-col p-5">
        <div className="mb-2 flex-row">
          <NeoHeader message="Deviation Settings"></NeoHeader>
        </div>
        <div className="mb-4 flex-row">
          <NeoBreadcrumb menus={breadCrumb}></NeoBreadcrumb>
        </div>
        <div className="grid grid-cols-1 items-stretch gap-3 sm:grid-cols-2 lg:grid-cols-2">
          <div className="flex h-full flex-col rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
            <div className="flex items-center gap-3">
              <img
                src="/icons/speed.svg"
                alt="Speed Deviation"
                className="h-7 w-7 flex-shrink-0"
              />
              <div>
                <h3 className="text-lg font-semibold text-gray-900">
                  Speed Deviation
                </h3>
                <p className="text-sm text-gray-500">
                  Monitor vehicle speed violations
                </p>
              </div>
            </div>
            <div className="mt-8 flex flex-1 items-center justify-center">
              <div className="relative w-full">
                <div
                  className="absolute -top-6 ml-3 w-12 rounded-md bg-black text-center text-white shadow-md"
                  style={{
                    left: `${speedTooltipPosition}px`,
                    transform: "translateX(-50%)"
                  }}
                >
                  {speedLimit.value}
                </div>
                <input
                  ref={speedDivRef}
                  type="range"
                  min={speedLimit.min}
                  max={speedLimit.max}
                  step="5"
                  value={speedLimit.value}
                  onChange={speedlimitchange}
                  className="h-4 w-full cursor-pointer rounded-full accent-black"
                />
                <div className="flex justify-between text-sm text-gray-500">
                  <span>{speedLimit.min} km/h</span>
                  <span>{speedLimit.max} km/h</span>
                </div>
              </div>
            </div>
            <div className="-ml-3 mt-auto flex hidden items-center gap-1">
              <NeoSwitchInput
                label=""
                activeLabel=""
                inActiveLabel=""
                //onValueChange={value => handleSwitchChange("speednotification", value)}
              />
              <h1 className="mt-2 text-base font-medium text-gray-900">
                Enable Notifications
              </h1>
            </div>
          </div>
          <div className="flex h-full flex-col rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
            <div className="flex items-center gap-3">
              <img
                src="/icons/distance.svg"
                alt="Distance Deviation"
                className="h-7 w-7 flex-shrink-0"
              />
              <div>
                <h3 className="text-lg font-semibold text-gray-900">
                  Distance Deviation
                </h3>
                <p className="text-sm text-gray-500">
                  Monitor vehicle distance violations
                </p>
              </div>
            </div>
            <div className="mt-8 flex flex-1 items-center justify-center">
              <div className="relative w-full">
                <div
                  className="absolute -top-6 ml-3 w-12 rounded-md bg-black text-center text-white shadow-md"
                  style={{
                    left: `${distanceTooltipPosition}px`,
                    transform: "translateX(-50%)"
                  }}
                >
                  {distanceLimit.value}
                </div>
                <input
                  ref={distanceDivRef}
                  type="range"
                  min={distanceLimit.min}
                  max={distanceLimit.max}
                  step="5"
                  value={distanceLimit.value}
                  onChange={distancelimitchange}
                  className="h-4 w-full cursor-pointer rounded-full accent-black"
                />
                <div className="flex justify-between text-sm text-gray-500">
                  <span>{distanceLimit.min} kms</span>
                  <span>{distanceLimit.max} kms</span>
                </div>
              </div>
            </div>
            <div className="-ml-3 mt-auto flex hidden items-center gap-1">
              <NeoSwitchInput
                label=""
                activeLabel=""
                inActiveLabel=""
                //onValueChange={value => handleSwitchChange("distancenotification", value)}
              />
              <h1 className="mt-2 text-base font-medium text-gray-900">
                Enable Notifications
              </h1>
            </div>
          </div>
          {showFuelLimit && (
            <div className="flex h-full flex-col rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
              <div className="flex items-center gap-3">
                <svg
                  width="25"
                  height="23"
                  viewBox="0 0 32 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M31.7286 12.4135C31.7286 12.2663 31.6913 12.1211 31.621 11.9923L26.2035 2.05409C25.9694 1.62383 25.428 1.46427 24.9925 1.69601C24.5586 1.92899 24.3973 2.46671 24.6314 2.89697L26.0054 5.41781L24.1959 8.55185C24.073 8.76432 24.0441 9.01657 24.116 9.25036C24.188 9.48415 24.3535 9.67815 24.5747 9.78644L29.7792 12.3401L29.9418 12.6383V19.9158C29.9418 20.9916 29.0595 21.8665 27.9754 21.8665H27.0345C25.9504 21.8665 25.069 20.9916 25.069 19.9158V15.1924C25.069 13.6407 23.7959 12.3782 22.2312 12.3782H20.906V3.13937C20.906 1.40726 19.4865 0 17.741 0H6.07306C4.32638 0 2.90728 1.40767 2.90728 3.13937V28.0903H0.893401C0.399963 28.0903 0 28.4877 0 28.9762C0 29.4647 0.399963 29.8622 0.893401 29.8622H22.4885C22.9811 29.8622 23.3811 29.4647 23.3811 28.9762C23.3811 28.4877 22.9811 28.0903 22.4885 28.0903H20.906V14.1501H22.2308C22.8099 14.1501 23.2818 14.6181 23.2818 15.1924V19.9158C23.2818 21.969 24.9652 23.6384 27.0341 23.6384H27.975C30.0447 23.6384 31.7281 21.969 31.7281 19.9158L31.7286 12.4135ZM26.218 8.61584L27.0055 7.25164L28.3076 9.64124L26.218 8.61584ZM13.8775 22.8123C13.3572 23.4021 12.6561 23.7266 11.9062 23.7266C10.3924 23.7266 9.15943 22.3743 9.15943 20.7135C9.16026 19.2571 11.0132 16.8273 11.3842 16.3556C11.6345 16.0385 12.1767 16.0352 12.4278 16.3556C12.7992 16.8273 14.6526 19.2579 14.6526 20.7135C14.653 21.501 14.3784 22.2471 13.8775 22.8123ZM16.4878 10.1593C16.4878 11.7638 15.1717 13.0698 13.5545 13.0698H9.68017C8.06294 13.0698 6.74601 11.7638 6.74601 10.1593V6.88906C6.74601 5.28451 8.06294 3.97856 9.68017 3.97856H13.5545C15.1717 3.97856 16.4878 5.28451 16.4878 6.88906V10.1593Z"
                    fill="#FFC727"
                  />
                </svg>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">
                    Fuel Deviation
                  </h3>
                  <p className="text-sm text-gray-500">
                    Monitor vehicle fuel violations
                  </p>
                </div>
              </div>
              <div className="mt-8 flex flex-1 items-center justify-center">
                <div className="relative w-full">
                  <div
                    className="absolute -top-6 ml-3 w-12 rounded-md bg-black text-center text-white shadow-md"
                    style={{
                      left: `${fuelTooltipPosition}px`,
                      transform: "translateX(-50%)"
                    }}
                  >
                    {fuelLimits.value}
                  </div>
                  <input
                    ref={fuelDivRef}
                    type="range"
                    min={fuelLimits.min}
                    max={fuelLimits.max}
                    step="5"
                    value={fuelLimits.value}
                    onChange={fuellimitschange}
                    className="h-4 w-full cursor-pointer rounded-full accent-black"
                  />
                  <div className="flex justify-between text-sm text-gray-500">
                    <span>{fuelLimits.min}%</span>
                    <span>{fuelLimits.max}%</span>
                  </div>
                </div>
              </div>
              <div className="-ml-3 mt-auto flex hidden items-center gap-1">
                <NeoSwitchInput
                  label=""
                  activeLabel=""
                  inActiveLabel=""
                  //onValueChange={value => handleSwitchChange("fuelnotification", value)}
                />
                <h1 className="mt-2 text-base font-medium text-gray-900">
                  Enable Notifications
                </h1>
              </div>
            </div>
          )}
        </div>
        <div className="mt-4 flex justify-end gap-5">
          <NeoButton type="button" color="white" onClick={onReset}>
            Cancel
          </NeoButton>
          <NeoButton className="" type="submit" onClick={onSubmit}>
            Save
          </NeoButton>
        </div>
      </div>
    </>
  );
};
